import InfoLayout from "./InfoLayout";

function Disclaimer() {
    return (
        <InfoLayout title="Disclaimer">
            <div>
              <h2>Development Care</h2>
                <p>
                    The <strong>Tabata Timer</strong> app is developed with the utmost care and focus on reliability, 
                    aiming to be a useful tool for your workouts. However, it cannot be guaranteed that it will always function 
                    without errors, interruptions, or technical issues.
                </p>

                <h2>Safety and Responsibility</h2>
                <p>
                    All exercises are performed at your own risk. The app serves only as a supportive tool 
                    for tracking workouts, planning intervals, and improving performance. It does not replace 
                    a personal trainer or medical consultation. We recommend exercising responsibly and adapting workouts 
                    to your own abilities, as everyone is responsible for their own health and safety.
                </p>

                <h2>Limitation of Liability</h2>
                <p>
                    The provider is not liable for any damages, injuries, data loss, time loss, or other 
                    consequences resulting from the use of the app. We recommend exercising responsibly and adjusting intensity 
                    according to your physical capabilities.
                </p>

                <h2>External Links</h2>
                <p>
                    The app may contain links to external third-party websites. The provider assumes no responsibility 
                    for the content of these websites, nor for their functionality or security.
                </p>

                <h2>No Guarantees</h2>
                <p>
                    The provider does not guarantee that the app will always be available, error-free, uninterrupted, or without 
                    functional limitations. Short-term outages, planned maintenance, or unexpected technical issues 
                    may occur and affect its availability or functionality.
                </p>

                <h2>Acceptance of Terms</h2>
                <p>
                    By using this app, you acknowledge that you have read, understood, and agree to this 
                    disclaimer. We recommend reviewing these terms carefully before regularly using the app.
                </p>
            </div>
        </InfoLayout>

    );
}

export default Disclaimer;
